import { createContext } from 'react';

const KYBCompanyContext = createContext();

export default KYBCompanyContext;